/**
 * Parse a date string from the API into a YYYY-MM-DD string for display.
 * Returns an empty string and logs an error if parsing fails.
 */
export function parseIsoDate(raw: string | null | undefined, context: { caseId: string }): string {
    if (!raw) return '';
    const parsed = new Date(raw);
    if (isNaN(parsed.getTime())) {
        console.error('[parseIsoDate] value is not a valid date', {
            value: raw,
            caseId: context.caseId,
        });
        return '';
    }
    return parsed.toISOString().slice(0, 10);
}
